import classBreaks from '@arcgis/core/smartMapping/statistics/classBreaks';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import ClassBreaksRenderer from '@arcgis/core/renderers/ClassBreaksRenderer';

// Store
import store from '../store/store';

// Configs
import { ATTRIBUTE_FIELD_FOR_POPULATION } from '../configs/attributeFields.configs';
import {
  DATA_VALUE_PRECISION,
  NO_VALUE,
  NO_VALUE_COLOR,
  ADMIN_1_BOUNDARY_OUTLINE_COLOR,
  ADMIN_2_OUTLINE_COLOR,
} from '../configs/map.configs';

export async function getAdminClassBreaksRenderer(FeaturesLayer: __esri.FeatureLayer) {
  const { adminSelected } = store.getState().sidebarMapFiltersSlice;
  const { colorRangeSelected, colorRangeSteps, rendererClassificationMethod, fieldSelected } =
    store.getState().sidebarMapFiltersSlice;

  const outlineColor = adminSelected === 'Admin1' ? ADMIN_1_BOUNDARY_OUTLINE_COLOR : ADMIN_2_OUTLINE_COLOR;
  const outlineWidth = adminSelected === 'Admin1' ? 2 : 0.5;
  const noValueClassBreak = {
    minValue: NO_VALUE,
    maxValue: NO_VALUE,
    label: 'No value',
    symbol: new SimpleFillSymbol({
      color: NO_VALUE_COLOR,
      outline: {
        color: outlineColor,
        width: outlineWidth,
      },
    }),
  };

  const definitionExpression = FeaturesLayer.definitionExpression;
  FeaturesLayer.definitionExpression = '1=1';
  const { classBreakInfos } = await classBreaks({
    layer: FeaturesLayer,
    field: fieldSelected,
    numClasses: colorRangeSteps,
    classificationMethod: rendererClassificationMethod,
  });
  FeaturesLayer.definitionExpression = definitionExpression;

  let classBreaksCustom = [noValueClassBreak];
  classBreakInfos.map((classBreakInfo: any, index: number) => {
    const { minValue: classBreakMinValue, maxValue: classBreakMaxValue } = classBreakInfo;
    if (classBreakMinValue === -1 && classBreakMaxValue === -1) return;

    const min = classBreakMinValue.toFixed(DATA_VALUE_PRECISION);
    const max = classBreakMaxValue.toFixed(DATA_VALUE_PRECISION);
    const minValue = index === 0 ? 0 : min;
    const maxValue = index < colorRangeSelected.length - 1 ? max : Infinity;

    const valueAdjustment = fieldSelected !== ATTRIBUTE_FIELD_FOR_POPULATION ? 0.1 : 1;
    const minValueLabel = new Intl.NumberFormat('en-US').format(
      (classBreakMinValue + valueAdjustment).toFixed(DATA_VALUE_PRECISION)
    );
    const maxValueLabel = new Intl.NumberFormat('en-US').format(maxValue);
    const label =
      index === 0
        ? `Up to ${maxValueLabel}`
        : index < colorRangeSelected.length - 1
          ? `${minValueLabel} - ${maxValueLabel}`
          : `${minValueLabel} and higher`;

    classBreaksCustom.push({
      minValue: classBreakMinValue,
      maxValue: classBreakMaxValue,
      label: label,
      symbol: new SimpleFillSymbol({
        color: colorRangeSelected[index],
        outline: {
          color: outlineColor,
          width: outlineWidth,
        },
      }),
    });
  });

  const admin1ClassBreaksRenderer = new ClassBreaksRenderer({
    field: fieldSelected, // values returned by this field will
    valueExpressionTitle: 'Legend', // Title of the value expression, appears in the legend
    classBreakInfos: classBreaksCustom,
  });

  return admin1ClassBreaksRenderer;
}
